// extracted by mini-css-extract-plugin
export var colors = "'colors.module.css'";
export var orangeText = "#FF5A09";
export var whiteText = "#dcdcdc";
export var cream = "#1d1e22";
export var list = "Projects-module--list--ZQDDt";
export var ghLink = "Projects-module--ghLink--Wo8ee";
export var divider = "Projects-module--divider--GmbPH";
export var header = "Projects-module--header--DO6YD";